module.exports = __webpack_public_path__ + "static/media/iconLogo.2cf266d7.svg";